export const module = {
  info: {
    name: 'voip-vendor-destination-status-menu',
    caption: 'voip vendor destination status menu',
    viewGroup: 'general-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Vendor & destination Status',
    icon: 'el-icon-folder',
    routeName: 'module->voip-vendor-destination-status->list->page',
    routeParams: { listPage: 1}
    /*children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-vendor-destination-status-menu->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-vendor-destination-status-menu->list->page',
        routeParams: { listPage: 1}
      }
    ]*/
  }
}

export default module
